import * as Sentry from '@sentry/vue'
import config from '@/config'
import util from '@/util'

export const CONSENT_TYPES = {
  ANALYTICS: 'analytics',
  ADVERTISEMENT: 'advertisement',
}

export const ALL_CONSENTS = [
  'performance',
  'targeting',
  'functionality',
]

const COOKIE_CONSENT_KEY = 'CookieScriptConsent'

// THE REASON WE NEED THIS BECAUSE OUR COOKIE DEFINITIONS IS SLIGHTLY DIFFERENT FROM COOKIE-SCRIPT
const CONSENT_TYPE_MAP = {
  performance: CONSENT_TYPES.ANALYTICS,
  targeting: CONSENT_TYPES.ADVERTISEMENT,
}

const CONSENT_CALLBACK_STORE = {
  analytics: [],
  advertisement: [],
}

const _getConsentCallbacks = (type) => {
  return CONSENT_CALLBACK_STORE[type]
}

export const initThirdPartyScripts = (permissions) => {
  ALL_CONSENTS.forEach((category) => {
    const callbacks = _getConsentCallbacks(CONSENT_TYPE_MAP[category])
    if (!callbacks) return
    callbacks.forEach((callback) => {
      try {
        const hasConsent = permissions.includes(category)
        callback(hasConsent)
      } catch (error) {
        Sentry.captureException(new Error('Cookie Consent Utils > initThirdPartyScripts > Init Callback called'), {
          extra: {
            category,
            error,
          },
        })
      }
    })
  })
}

export const addToConsentCallbackStore = (type, callback) => {
  const callbacks = _getConsentCallbacks(type)
  if (!callbacks) return
  callbacks.push(callback)
}

export const getConsentFromCookie = () => {
  const cookieValue = util.getCookie(COOKIE_CONSENT_KEY)
  if (!cookieValue) return null
  return JSON.parse(cookieValue)
}

export const init = () => {
  if (document.getElementById('cookie-script')) {
    return
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.charset = 'UTF-8'
  script.src = `https://cdn.cookie-script.com/s/${config.cookieScriptId}.js`
  script.async = true
  script.id = 'cookie-script' // Add an ID to prevent duplicate loading
  document.head.appendChild(script)

  script.onload = () => {
  }

  script.onerror = () => {
  }

  window.addEventListener('CookieScriptLoaded', () => {
    // CookieScript.instance is available here
    // More information
    // https://help.cookie-script.com/en/javascript-code-documentation/custom-events
    // eslint-disable-next-line no-undef
    if (!CookieScript) return
    // eslint-disable-next-line no-undef
    const { categories: permissions } = CookieScript.instance.currentState()

    initThirdPartyScripts(permissions)
  })
}
